/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateUserModificationDto
 */
export interface UpdateUserModificationDto {

    /**
     * @type {Date}
     * @memberof UpdateUserModificationDto
     */
    date?: Date;

    /**
     * @type {number}
     * @memberof UpdateUserModificationDto
     */
    value?: number | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateUserModificationDto
     */
    mobility?: JoinEntityDto;

    /**
     * @type {string}
     * @memberof UpdateUserModificationDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateUserModificationDto
     */
    user?: JoinEntityDto | null;
}
